import { PaymentInvoiceType, SubmitType } from "../../types"

export const submitMap = (data: PaymentInvoiceType): SubmitType => {
  return {
    invoice_id: data.invoice_id ?? NaN,
    customer_id: data.customer_id,
    location_id: data.location_id,
    trx_code: data.trx_code ?? "",
    transaction_date: data.transaction_date,
    memo: data?.memo,
    no_cheque: data?.no_cheque,
    address: data?.shipped ?? "",
    referensi: data?.referensi,
    coa_id: data?.coa_id,
    deposit_amount: data?.deposit_amount,
    payment_amount: data?.payment_amount
  }
}
